import { BookOpen, Briefcase, FileText, GraduationCap, MessageSquareQuote, Award } from "lucide-react";
import { Link } from "react-router-dom";

export const MegaMenu = ({ menu, data, type, onClose, renderItem }) => {
    if (menu !== type) return null;

    return (
        <div
            className="fixed left-0 top-30 w-screen mt-1 z-50"
            onMouseEnter={() => onClose(type)}
            onMouseLeave={() => onClose(null)}
        >
            <div className="bg-white border border-slate-100 shadow-lg">
                <div
                    className="flex-1 px-5 py-10   max-h-[50vh] lg:max-h-[45vh] xl:max-h-[40vh]
  overflow-y-auto scrollbar-none"
                >
                    <div
                        className={`grid ${type === "services"
                            ? "grid-cols-2 xl:grid-cols-4 gap-4"
                            : "grid-cols-2 xl:grid-cols-4 gap-5"
                            }`}
                    >
                        {data.map(renderItem)}
                    </div>
                </div>
            </div>
        </div>
    );
};

export const NavItem = ({ title, to, menu, setOpenMenu, className }) => (
    <Link
        to={to}
        onMouseEnter={() => setOpenMenu(menu)}
        onMouseLeave={() => setOpenMenu(null)}
        className={
            className ??
            "text-xs font-bold uppercase hover:text-blue-600"
        }
    >
        {title}
    </Link>
);

export const MenuCard = ({ title, to, onClick }) => {
    const initials = title
        .split(" ")
        .map((word) => word[0])
        .slice(0, 2)
        .join("")
        .toUpperCase();

    return (
        <Link
            to={to}
            onClick={onClick}

            className="
        group relative overflow-hidden
        flex flex-col items-center justify-center
        text-center

        h-28 md:h-32 xl:h-36
        rounded-xl
        border border-slate-200
        bg-white

        p-3 md:p-4
        transition-all duration-300
        hover:-translate-y-1
        hover:border-blue-500
        hover:shadow-lg
      "
        >
            <div className="absolute -top-8 -right-8 h-20 w-20 rounded-full bg-blue-100 opacity-0 transition-all duration-500 group-hover:opacity-40 group-hover:scale-125" />

            <div
                className="
          relative z-10
          flex items-center justify-center

          h-10 w-10
          md:h-12 md:w-12
          xl:h-14 xl:w-14

          rounded-xl
          bg-blue-50
          text-blue-600

          text-sm md:text-base xl:text-lg
          font-bold

          transition-all duration-300
          group-hover:scale-110
          group-hover:-translate-y-1
        "
            >
                {initials}
            </div>

            <h3
                className="
          relative z-10
          mt-3 md:mt-4
          px-1
          text-xs md:text-sm
          font-bold
          text-slate-900
          transition-colors
          group-hover:text-blue-600
          line-clamp-2
        "
            >
                {title}
            </h3>
        </Link>
    );
};

export const resourceItems = [
    {
        title: "Blogs",
        path: "/blogs",
        icon: <BookOpen />,
        color: "bg-blue-50 text-blue-600",
        description: "Latest articles, news & industry insights.",
    },
    {
        title: "Projects",
        path: "/projects",
        icon: <Briefcase />,
        color: "bg-emerald-50 text-emerald-600",
        description: "Explore our completed surveillance projects.",
    },

    {
        title: "Reviews",
        path: "/reviews",
        icon: <MessageSquareQuote />,
        color: "bg-purple-50 text-purple-600",
        description: "Customer experiences and testimonials.",
    },
    {
        title: "Careers",
        path: "/careers",
        icon: <GraduationCap />,
        color: "bg-rose-50 text-rose-600",
        description: "Join our team and build your career.",
    },
    {
    title: "Portfolio",
    path: "/portfolio",
    icon: <Award />,
    color: "bg-rose-50 text-rose-600",
        description: "Join our team and build your career.",
  },
    {
        title: "Terms & Conditions",
        path: "/terms-and-conditions",
        icon: <FileText />,
        color: "bg-blue-50 text-blue-600",
        description:
            "Review our service, payment, warranty, installation and customer terms.",
    },
];
